import styled, { css } from 'styled-components';
import { imHere } from '../../Animation';
import paper_small from '../../../../asset/paper_small.png';


// Naming convention:
// Do not naming when it used for
// Do naming explain their characteristics
// Do not setting position value. why? position is depends in situation.
// cursor: pointer is default.

const hoverScale = css`
  &:hover {
    transform: scale(0.98);
  }
  transition: transform 0.2s ease-in-out;
`;

const blurBackground = css`
  background-color: ${({ theme }) => theme.colors.color_Alpha_03};
  backdrop-filter: blur(4px);
`;

const blackBackground = css`
  background-color: ${({ theme }) => theme.colors.color_Gray_01};
  color: ${({ theme }) => theme.colors.color_White};
`;

const paperBackground = css`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${paper_small});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.4;
    z-index: -1;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const boxShadow = css`
  box-shadow:
    inset 1px 1px 2px 0 rgba(255, 255, 255, 0.35),
    inset -1px -1px 2px 0 rgba(0, 0, 0, 0.2);
`;

const smallFitBtn = css`
  width: fit-content;
`;

const smallBtnStyles = css`
  padding: 8px 1rem;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_01};
  white-space: nowrap;
`;

const centerAlign = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;



/**
 * 하얀 버튼 (완)
 */
export const PaperBlurFitBtn = styled.button`
  ${smallBtnStyles}
  ${smallFitBtn}
  ${centerAlign}
  ${boxShadow}
  ${paperBackground}
  ${blurBackground}
  ${hoverScale}
`;

/**
 * 검정 버튼 width 100%
 */
export const BlackFullWidthBtn = styled.button`
  ${smallBtnStyles}
  ${centerAlign}
  ${blackBackground}
  ${boxShadow}
  ${hoverScale}
`;

/**
 * 검정 버튼 가만히
 */
export const BlackFitBtn = styled.button`
  ${smallBtnStyles}
  ${smallFitBtn}
  ${centerAlign}
  ${blackBackground}
  ${boxShadow}
  ${hoverScale}
`;

/**
 * 검정 버튼 imHere
 */
export const BlackFitBtnHeartbeat = styled.button`
  ${smallBtnStyles}
  ${smallFitBtn}
  ${centerAlign}
  ${blackBackground}
  ${hoverScale}
  ${imHere}
`;